import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { useAuth } from 'context/AuthProvider.js';
import { httpClient } from 'helpers/HttpClient.js';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import AutocompleteDropdown from 'componentes/generic/AutoComplete.js';
import { Controller, useForm } from 'react-hook-form';
import { isNullOrEmpty } from 'helpers/FormatData';
import DatePicker from 'react-datepicker';
import CustomDateInput from 'componentes/common/CustomDateInput';
const URIAdmin = ApiEndpoint + 'administration/';
const URIconfig = ApiEndpoint + 'configuration/';
const URIOperations = ApiEndpoint + 'operations/';
const EditExpedienteData = ({
  idQueja,
  setErrorMesagge,
  setShowErrorMessage,
  setIsError,
  closeModal
}) => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [customers, setCustomers] = useState(null);
  const [subCustomers, setSubCustomers] = useState([]);
  const [determinantes, setDeterminantes] = useState([]);
  const [idCustomer, setIdCustomer] = useState(null);
  const [fechadevolucion, setFechadevolucion] = useState(null);
  const [fechacompra, setFechacompra] = useState(null);
  const [idSubCustomer, setIdSubCustomer] = useState(null);
  const [tiposEvento, setTiposEvento] = useState(null);
  const [formatosQueja, setFormatosQueja] = useState(null);
  const [clasificacionesQuejaProfeco, setClasificacionesQuejaProfeco] =
    useState(null);
  const [delegacionesProfeco, setDelegacionesProfeco] = useState(false);
  const [selectedDelegacionDescription, setSelectedDelegacionDescription] =
    useState('');
  const [selectedSubcustomerDescription, setSelectedSubcustomerDescription] =
    useState('');
  const [selectedDeterminanteDescription, setSelectedDeterminanteDescription] =
    useState('');
  const [
    selectedClasificacionProfecoDescription,
    setSelectedClasificacionProfecoDescription
  ] = useState('');
  const {
    register,
    formState: { errors },
    control,
    handleSubmit,
    setValue
  } = useForm({
    defaultValues: {
      expediente: '',
      idCustomer: 0,
      subcustomer: 0,
      determinante: 0,
      idtipoevento: 0,
      clasificacionQuejaProfeco: 0,
      delegacion: 0,
      idformato: 0,
      fechadevolucion: null,
      fechacompra: null,
      seller: null
    }
  });
  const getCustomers = async () => {
    setCustomers(null);

    httpClient('GET', URIAdmin + 'customers/', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          var customersList = response.data.map(item => {
            return { value: item.idcliente, label: item.razonsocial };
          });
          setCustomers(customersList);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const getDelegacionesProfeco = async () => {
    setDelegacionesProfeco(null);

    httpClient('GET', URIAdmin + 'delegations/', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          var deleg = response.data.map(item => {
            return { id: item.iddelegacion, description: item.nombre };
          });
          setDelegacionesProfeco(deleg);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };

  const getSubCustomers = async idcustomer => {
    setSubCustomers(null);
    console.log(idCustomer);
    httpClient(
      'GET',
      URIAdmin + 'subcustomers/' + idcustomer,
      {},
      userData.token
    )
      .then(function (response) {
        if (!response.data.error) {
          var subcustList = response.data.map(item => {
            return {
              id: item.idsubcliente,
              description: item.descripcion
            };
          });
          setSubCustomers(subcustList);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const getDeterminantes = async () => {
    setDeterminantes(null);

    httpClient(
      'GET',
      URIAdmin + 'determinantes/' + idSubCustomer,
      {},
      userData.token
    )
      .then(function (response) {
        if (!response.data.error) {
          var subcustList = response.data.map(item => {
            return {
              id: item.iddeterminante,
              description: item.determinante + ' - ' + item.unidad
            };
          });
          setDeterminantes(subcustList);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const getQuejaExpediente = async () => {
    httpClient(
      'POST',
      URIOperations + 'quejaexpediente/',
      { idqueja: idQueja },
      userData.token
    )
      .then(function (response) {
        if (!response.data.error) {
          let queja = response.data;
          setIdCustomer(queja.idcliente);
          getSubCustomers(queja.idcliente);
          setIdSubCustomer(queja.idsubcliente);
          setValue('expediente', queja.numeroqueja);
          setValue('seller', queja.seller);
          setValue('idCustomer', queja.idcliente);
          setValue(
            'clasificacionQuejaProfeco',
            queja.idclasificacionquejaprofeco
          );
          setValue('subcustomer', queja.idsubcliente);
          setValue('determinante', queja.iddeterminante);
          setValue('idtipoevento', queja.idtipoevento);
          setValue('idformato', queja.idformatoqueja);
          setValue('delegacion', queja.iddelegacion);
          setFechadevolucion(queja.fechadevolucion);
          setFechacompra(queja.fechacompra);

          setSelectedDelegacionDescription(queja.delegacion);
          setSelectedClasificacionProfecoDescription(
            queja.clasificacionprofeco ?? 'No Seleccionado'
          );
          setSelectedSubcustomerDescription(queja.subcustomer);
          setSelectedDeterminanteDescription(queja.determinante);
        }
      })
      .then(function () {})
      .catch(function (error) {
        console.log(error);
      });
  };
  const getTiposEventos = async () => {
    setTiposEvento(null);

    httpClient('GET', URIconfig + 'eventtypes/', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          var tiposPlataforma = response.data.map(item => {
            return { value: item.idtipoeventos, label: item.descripcion };
          });
          setTiposEvento(tiposPlataforma);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const getClasificacionesQuejaProfeco = async () => {
    setClasificacionesQuejaProfeco(null);

    httpClient('GET', URIAdmin + 'clasificationsprofeco/', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          var clasificaciones = response.data.map(item => {
            return {
              id: item.idclasificacionquejaprofeco,
              description: `${item.descripcion}`
            };
          });
          setClasificacionesQuejaProfeco(clasificaciones);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    if (idSubCustomer) getDeterminantes();
  }, [idSubCustomer]);

  useEffect(() => {
    const loadData = async () => {
      if (!delegacionesProfeco) await getDelegacionesProfeco();
      if (!customers) await getCustomers();
      if (!formatosQueja) await getFormatosQueja();
      if (!tiposEvento) await getTiposEventos();
      if (!clasificacionesQuejaProfeco) getClasificacionesQuejaProfeco();

      // Now that everything is ready
      await getQuejaExpediente();
    };

    loadData();
  }, []);

  const getFormatosQueja = async () => {
    setFormatosQueja(null);

    httpClient('GET', URIAdmin + 'formatosqueja/', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          var tiposPlataforma = response.data.map(item => {
            return { value: item.idformatoqueja, label: item.formato };
          });
          setFormatosQueja(tiposPlataforma);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const onSubmit = data => {
    console.log(data);
    httpClient(
      'POST',
      URIOperations + 'updateExpedienteData/' + idQueja,
      { data },
      userData.token
    )
      .then(function (response) {
        if (!response.data.error) {
          closeModal();
          setIsError(false);
          setErrorMesagge('Expediente Actualizado con exito');
          setShowErrorMessage(true);
        } else {
          setIsError(true);
          setErrorMesagge('Ha ocurrido un error al registrar el cierre');
          setShowErrorMessage(true);
        }
      })
      .catch(function (error) {
        console.log(error);
        setIsError(true);
        setErrorMesagge('Ha ocurrido un error al registrar el cierre');
        setShowErrorMessage(true);
      })
      .finally(() => {});
  };
  return (
    <>
      <Card style={{ width: '100%' }}>
        <Card.Body>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Row className="g-2 mb-3">
              <Col>
                <Controller
                  name="expediente"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <Form.Group>
                      <Form.Label>Expediente</Form.Label>
                      <Form.Control
                        type={'text'}
                        placeholder={'Expediente'}
                        name="expediente"
                        {...field}
                        isInvalid={!!errors.expediente}
                        isValid={
                          Object.keys(errors).length > 0 && !errors.expediente
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.expediente?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  )}
                />
              </Col>
            </Row>
            <Row className="g-2 mb-3">
              <Col>
                {delegacionesProfeco &&
                  delegacionesProfeco.length > 0 &&
                  !isNullOrEmpty(selectedDelegacionDescription) && (
                    <AutocompleteDropdown
                      items={delegacionesProfeco}
                      addFunction={() => {}}
                      addButton={false}
                      name="delegacion"
                      register={register}
                      errors={errors}
                      placeholder="Selecciona una Delegacion"
                      currentSelected={selectedDelegacionDescription}
                      setCurrentSelected={value => {
                        setSelectedDelegacionDescription(value.description);
                        //setIdSubCustomer(value.id);
                      }}
                      setValue={setValue}
                    />
                  )}
              </Col>
            </Row>
            <Row className="g-2 mb-3">
              {customers && (
                <>
                  <Controller
                    name="idCustomer"
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <Form.Group>
                        <Form.Label>Cliente</Form.Label>
                        <Form.Select
                          type="select"
                          name="idCustomer"
                          value={field.value}
                          onChange={e => {
                            console.log('idcust', e.target.value);
                            setIdCustomer(e.target.value); // update local state
                            field.onChange(e); // call form library handler
                            setSelectedSubcustomerDescription('');
                            setIdSubCustomer(0);
                            setSelectedDeterminanteDescription('');
                            setValue('determinante', 0);
                            getSubCustomers(e.target.value);
                          }}
                          isInvalid={!!errors.idCustomer}
                          isValid={
                            Object.keys(errors).length > 0 && !errors.idCustomer
                          }
                        >
                          <option value="">Selecciona un cliente</option>
                          {customers.map(option => (
                            <option value={option.value} key={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.idCustomer?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    )}
                  />
                </>
              )}
            </Row>
            <Row className="g-2 mb-3">
              <Col>
                {subCustomers && (
                  <AutocompleteDropdown
                    items={subCustomers || []}
                    placeholder="Selecciona un Sub Cliente"
                    currentSelected={selectedSubcustomerDescription}
                    name="subcustomer"
                    register={register}
                    errors={errors}
                    addFunction={() => {}}
                    addButton={false}
                    setCurrentSelected={value => {
                      setSelectedSubcustomerDescription(value.description);
                      setIdSubCustomer(value.id);
                    }}
                    setValue={setValue}
                  />
                )}
              </Col>
            </Row>
            <Row className="g-2 mb-3">
              <Col>
                {determinantes && (
                  <AutocompleteDropdown
                    items={determinantes || []}
                    placeholder="Selecciona un Determinante"
                    currentSelected={selectedDeterminanteDescription}
                    name="determinante"
                    addFunction={() => {}}
                    addButton={false}
                    register={register}
                    errors={errors}
                    setCurrentSelected={value => {
                      setSelectedDeterminanteDescription(value.description);
                    }}
                    setValue={setValue}
                  />
                )}
              </Col>
            </Row>
            <Row className="g-2 mb-3">
              <Col>
                {tiposEvento && (
                  <Form.Group>
                    <Form.Label>Tipo de Evento</Form.Label>
                    <Form.Select
                      {...register('idtipoevento', {
                        required: 'Selecciona un Tipo de Evento'
                      })}
                      type="select"
                      isInvalid={!!errors.idtipoevento}
                    >
                      <option value="">Selecciona un tipo de Evento</option>
                      {tiposEvento.map(option => (
                        <option value={option.value} key={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      {errors.idtipoevento?.message}
                    </Form.Control.Feedback>
                  </Form.Group>
                )}
              </Col>
            </Row>
            <Row className="g-2 mb-3">
              <Col>
                {selectedClasificacionProfecoDescription &&
                  clasificacionesQuejaProfeco && (
                    <AutocompleteDropdown
                      items={clasificacionesQuejaProfeco}
                      placeholder="Selecciona una clasificacion de queja (Profeco)"
                      currentSelected={selectedClasificacionProfecoDescription}
                      name="clasificacionQuejaProfeco"
                      register={register}
                      errors={errors}
                      setValue={setValue}
                      addButton={false}
                      setCurrentSelected={value => {
                        setSelectedClasificacionProfecoDescription(
                          value.description
                        );
                      }}
                    />
                  )}
              </Col>
            </Row>
            <Row>
              <Col>
                {formatosQueja && (
                  <Form.Group>
                    <Form.Label>Formato de Queja</Form.Label>
                    <Form.Select
                      {...register('idformato', {
                        required: 'Selecciona un Formato de Queja'
                      })}
                      type="select"
                      isInvalid={!!errors.idformato}
                    >
                      <option value="">Selecciona un Formato</option>
                      {formatosQueja.map(option => (
                        <option value={option.value} key={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      {errors.idformato?.message}
                    </Form.Control.Feedback>
                  </Form.Group>
                )}
              </Col>
            </Row>
            <Row className="g-2 mb-3">
              <Col>
                <Controller
                  name="seller"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <Form.Group>
                      <Form.Label>Nombre de Seller</Form.Label>
                      <Form.Control
                        type={'text'}
                        placeholder={'seller'}
                        name="seller"
                        {...field}
                        isInvalid={!!errors.seller}
                        isValid={
                          Object.keys(errors).length > 0 && !errors.seller
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.seller?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  )}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>Fecha de Compra</Form.Label>
                  <DatePicker
                    selected={fechacompra}
                    onChange={date => {
                      setFechacompra(date);
                      setValue('fechaCompra', date);
                    }}
                    customInput={
                      <CustomDateInput
                        errorMessage={errors.fechaCompra}
                        isInvalid={errors.fechaCompra}
                        isValid={
                          Object.keys(errors).length > 0 && !errors.fechaCompra
                        }
                      />
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.fechaCompra?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>Fecha de Devolucion</Form.Label>
                  <DatePicker
                    selected={fechadevolucion}
                    onChange={date => {
                      setFechadevolucion(date);
                      setValue('fechaDevolucion', date);
                    }}
                    customInput={
                      <CustomDateInput
                        errorMessage={errors.fechaDevolucion}
                        isInvalid={errors.fechaDevolucion}
                        isValid={
                          Object.keys(errors).length > 0 &&
                          !errors.fechaDevolucion
                        }
                      />
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.fechaDevolucion?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Button type="submit" color="primary" size="sm">
                  Guardar
                </Button>
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>
    </>
  );
};
EditExpedienteData.propTypes = {
  idQueja: PropTypes.number.isRequired,
  closeModal: PropTypes.func,
  setErrorMesagge: PropTypes.func,
  setShowErrorMessage: PropTypes.func,
  setIsError: PropTypes.func
};

export default EditExpedienteData;
